module.exports = __webpack_public_path__ + "img/pricing-card-img.630f204b.png";